export var MPAOperationScope;
(function (MPAOperationScope) {
    MPAOperationScope["MPA_OPERATION_SCOPE_UNSPECIFIED"] = "MPA_OPERATION_SCOPE_UNSPECIFIED";
    MPAOperationScope["MPA_OPERATION_SCOPE_BACKUP_POLICY"] = "MPA_OPERATION_SCOPE_BACKUP_POLICY";
    MPAOperationScope["MPA_OPERATION_SCOPE_CLOUD_RESOURCE"] = "MPA_OPERATION_SCOPE_CLOUD_RESOURCE";
})(MPAOperationScope || (MPAOperationScope = {}));
